const initPastRecipients = () => {
    const root = document.querySelector('[data-past-recipients]');

    if (!root) {
        return;
    }

    const yearToggles = Array.from(root.querySelectorAll('[data-year-toggle]'));
    const recipientSection = document.querySelector('[data-recipient-section]');

    if (!yearToggles.length || !recipientSection) {
        return;
    }

    const recipientBlocks = Array.from(recipientSection.querySelectorAll('[data-recipient-year]'));

    const setActiveYear = (year) => {
        if (!year) {
            return;
        }

        yearToggles.forEach((toggle) => {
            toggle.classList.toggle('active', toggle.dataset.year === year);
        });

        recipientBlocks.forEach((block) => {
            const isActive = block.dataset.recipientYear === year;

            block.classList.toggle('active', isActive);
            block.style.display = isActive ? '' : 'none';
        });
    };

    const defaultYear = root.dataset.defaultYear || yearToggles[0]?.dataset.year;

    setActiveYear(defaultYear);

    yearToggles.forEach((toggle) => {
        toggle.addEventListener('click', () => {
            setActiveYear(toggle.dataset.year);
        });
    });
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPastRecipients);
} else {
    initPastRecipients();
}
